export default "__VITE_ASSET__D6I6dBMU__"